import { useEffect, useRef, useState } from "react";
import { subscribe } from "./scrollManager";

export function useGlobalSticky(ref: React.RefObject<HTMLDivElement>) {
    const [top, setTop] = useState(0);
    const initialTopRef = useRef<number | null>(null);

    useEffect(() => {
        if (!ref.current) return;

        initialTopRef.current =
            ref.current.getBoundingClientRect().top + window.scrollY;

        const update = () => {
            if (initialTopRef.current === null) return;

            const fixedHeaderHeight = document.getElementById("ResponsiveHeader")?.offsetHeight ?? 0;
            const offset = Math.max(
                0,
                window.scrollY - initialTopRef.current + fixedHeaderHeight
            );

            setTop(offset);
        };

        const unsubscribe = subscribe(update);

        update();

        return () => {
            initialTopRef.current = null;
            unsubscribe();
        };
    }, [ref]);

    return { top };
}
